// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div_template[data-v-6e77c9dc]{display:block}.span_title[data-v-6e77c9dc]{font-weight:700;font-size:14px;border-bottom:1px solid #ccc;padding:5px 0;font-size:12px;margin:10px 0}.span_props[data-v-6e77c9dc]{font-size:12px;display:block;margin-block-start:1em;margin-block-end:1em;margin-inline-start:0px;margin-inline-end:0px;margin:10px 0}\n", ""]);
// Exports
module.exports = exports;
